/**
 * Shared layout tokens for standalone apps (GetOnTheMap, ChartMind, SymptomChecker).
 * Use for congruent rounded containers and section cards; no color changes.
 */

import { tokens } from '@healthdesk/shared-utils';

export const RADIUS_SMALL = tokens.radius.card;
export const RADIUS_MEDIUM = tokens.radius.dialog;
export const RADIUS_LARGE = tokens.radius.chip;

export const CONTENT_PADDING = 2;

/** Spread onto MUI Paper (and set elevation={0}) for section cards. */
export const contentCardSx = {
  borderRadius: RADIUS_MEDIUM,
  border: '1px solid',
  borderColor: 'divider',
};
